// extracted by mini-css-extract-plugin
export var headerCell = "_41-1";
export var loadingSpinnerContainer = "_41-4";
export var rowWrapper = "_41-3";
export var standaloneTable = "_41-5";
export var table = "_41-0";
export var white = "_41-2";